import { doc, updateDoc } from "firebase/firestore";
import { auth, db, logout } from "../_shoru_shared_library/firebase/firebase_setup";
import { useEffect, useRef, useState } from "react";
import PageLoader from "../_shoru_shared_library/loaders/PageLoader";
import Logo from '../_media/branding/logo.svg';
import { applyActionCode, checkActionCode } from "firebase/auth";


export function EmailChangeComplete() {

  const [success, setSuccess] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if(started.current) return;
    started.current = true;

    completeEmailChange()
      .then(() => {
        setSuccess(true);
        logout(false);
      })
      .catch((error) => {
        console.error(error);
        setSuccess(false);
      })
  }, [])

  if(success === null) return <PageLoader />

  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '30px', marginTop: '50px'}}>
      <img src={Logo} width='100px' />
      {
        success
        ? <>
            <h2>
              Email updated successfully
            </h2>
            <p style={{margin: 0}}>You can now continue to Shoru</p>
          </>
        : <>
            <h2>
              Email could not be updated
            </h2>
            <button onClick={() => window.location.reload()}>Try Again</button>
            <p>Please make sure you are <a href='https://casting.shoru.app/login'>signed in</a></p>
          </>
      }
    </div>
  )
}



async function completeEmailChange() {
  const params = new URLSearchParams(window.location.search);

  const mode = params.get('mode');
  const oobCode = params.get('oobCode');

  if(mode !== 'verifyAndChangeEmail' || !oobCode) throw new Error('Invalid email-change link');

  const actionInfo = await checkActionCode(auth, oobCode);
  const newEmail = actionInfo.data.email;

  if(!newEmail) throw new Error('The verification link contains no email address');

  const user = auth.currentUser;

  if(!user) throw new Error('Your email was verified, but you must sign in again to finish updating your account');

  await user.getIdToken(true);

  await updateDoc(doc(db, 'users', user.uid), {email: newEmail});

  await applyActionCode(auth, oobCode);

}